__turbopack_context__.v({
  "Content": "footer-module-scss-module__BFu86a__Content",
  "mailLink": "footer-module-scss-module__BFu86a__mailLink",
});
